"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tivoli": {
    "a2889413": [{
      "hkey": "b8d943d7",
      "slug": "tivoli-terme",
      "name": "Tivoli Terme",
      "primary": true,
      "skipSearch": false
    }],
    "bagni-di-tivoli": [{
      "hkey": "b8d943d7",
      "slug": "tivoli-terme",
      "name": "Tivoli Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tivoli"
    }],
    "2dfa74f6": [{
      "hkey": "9df54c2d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tivoli-citta": [{
      "hkey": "9df54c2d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;